// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as BlacklistType from "../../../view/components/types/BlacklistType.bs.js";
import * as WhitelistPartnerPayloadApiModel from "../api-model/WhitelistPartnerPayloadApiModel.bs.js";

function entityToApiModel(entity) {
  return {
          msisdn: entity.msisdn,
          whitelistTypes: Belt_Array.map(entity.whitelistTypes, BlacklistType.toApiValue),
          comment: entity.comment
        };
}

function execute(entity) {
  return WhitelistPartnerPayloadApiModel.t_encode(entityToApiModel(entity));
}

export {
  entityToApiModel ,
  execute ,
  
}
/* No side effect */
